import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center" data-id="element-288">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-289" />

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-2xl w-full max-w-4xl max-h-[90vh] m-4 flex flex-col" data-id="element-290">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-291">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-292">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close" data-id="element-293">
            <X className="w-6 h-6 text-gray-600" data-id="element-294" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-6 flex-1" data-id="element-295">{children}</div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200" data-id="element-296">
          <button onClick={onClose} className="w-full bg-[#4CAF50] text-white py-3 px-6 rounded-lg font-semibold hover:bg-[#45a049] transition-colors" data-id="element-297">
            Close
          </button>
        </div>
      </div>
    </div>;
}